import apiClient from "@/services/apiClient";
import type { TeamCreate, TeamResponse, TeamUpdate, TeamsResponse } from "@/types/team";


export const teamService = {
  /**
   * Get all teams for current user
   * GET /v1/teams
   */
  async getTeams(): Promise<TeamsResponse> {
    const response = await apiClient.get('/v1/teams');
    return response.data;
  },

  /**
   * Get specific team with permissions check
   * GET /v1/teams/{team_id}
   */
  async getTeam(teamId: string): Promise<TeamResponse> {
    const response = await apiClient.get(`/v1/teams/${teamId}`);
    return response.data;
  },

  /**
   * Create new team (automatically adds creator as admin)
   * POST /v1/teams
   */
  async createTeam(data: TeamCreate): Promise<TeamResponse> {
    const formData = new FormData();
    formData.append('name', data.name);

    if (data.description) {
      formData.append('description', data.description);
    }

    formData.append('visibility', data.visibility);

    if (data.logo) {
      formData.append('logo', data.logo);
    }

    const response = await apiClient.post('/v1/teams', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  /**
   * Update team (requires manage permissions)
   * PUT /v1/teams/{team_id}
   */
  async updateTeam(teamId: string, data: TeamUpdate): Promise<TeamResponse> {
    const formData = new FormData();

    if (data.name) {
      formData.append('name', data.name);
    }

    if (data.description !== undefined) {
      formData.append('description', data.description);
    }

    if (data.visibility) {
      formData.append('visibility', data.visibility);
    }

    if (data.logo) {
      formData.append('logo', data.logo);
    }

    const response = await apiClient.put(`/v1/teams/${teamId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  /**
   * Delete team (requires manage permissions)
   * DELETE /v1/teams/{team_id}
   */
  async deleteTeam(teamId: string): Promise<void> {
    return await apiClient.delete(`/v1/teams/${teamId}`);
  },
}; 